import { useEffect } from 'react'

import ReactToolTip from 'react-tooltip'

import { Container } from './styles'

let rebuildTimeout: ReturnType<typeof setTimeout> | null = null
let mountedTooltips = 0

const scheduleTooltipRebuild = () => {
  if (rebuildTimeout) return

  rebuildTimeout = setTimeout(() => {
    ReactToolTip.rebuild()
    rebuildTimeout = null
  }, 80)
}

interface TooltipProps {
  id: string
  disabledValues?: boolean
  content: JSX.Element
  place?: 'top' | 'right' | 'bottom' | 'left'
  fixed?: boolean
}

const Tooltip = ({
  id,
  disabledValues = false,
  content,
  place = 'bottom',
  fixed = false
}: TooltipProps) => {
  useEffect(() => {
    mountedTooltips += 1
    if (!disabledValues) {
      scheduleTooltipRebuild()
    }

    return () => {
      mountedTooltips -= 1
      if (mountedTooltips <= 0 && rebuildTimeout) {
        clearTimeout(rebuildTimeout)
        rebuildTimeout = null
      }
    }
  }, [disabledValues])

  return (
    <Container>
      <ReactToolTip
        className='tooltip-container'
        id={id}
        place={place} // top, bottom, left, right
        effect={fixed ? 'solid' : 'float'}
      >
        {content}
      </ReactToolTip>
    </Container>
  )
}

export default Tooltip
